import React from "react";
import styled from "styled-components";
import { FIELDS } from "constants/PostFormFields";
import { SwitchField } from "./SwitchField";
import { useFlushPending } from "../platform-fields/flush-registry";

export function SwitchIsStoryOrNotification({
  selectedPlatform,
  postFormValue,
  updateField,
  allDisabled,
  platforms,
  platformFields,
}) {
  const flushPending = useFlushPending();
  return (
    <SwitchFieldStyled
      label="Switch to Instagram Story"
      compact
      defaultChecked={postFormValue.isStory === true}
      onChange={() => {
        // Toggling Story remounts field editors; flush in-flight edits first.
        flushPending();
        updateField(FIELDS.IS_STORY, !postFormValue.isStory);
        updateField(FIELDS.PUBLISH_STORY_MANUALLY);
      }}
      disabled={
        allDisabled ||
        (selectedPlatform !== "LINKED" &&
          (!platforms || (platforms && platforms.length > 1)) &&
          (!platformFields[selectedPlatform] ||
            platformFields[selectedPlatform].unlinked !== true))
      }
    />
  );
}

const SwitchFieldStyled = styled(SwitchField)`
  margin-bottom: 12px;
`;
